export type HostTelemetryEventType = 'PAGE_VIEW' | 'TAB_VIEW' | 'ACTION' | 'LOGIN';

export interface HostTelemetryPayload {
  event_type: HostTelemetryEventType;
  feature_name: string;
  action_name?: string;
  page_route?: string;
  tab_name?: string;
  metadata?: Record<string, any>;
}

export const HOST_ROUTE_FEATURE_NAME_MAP: Record<string, string> = {
  '/host/livestream-calendar': 'Livestream Calendar',
  '/host/live-confirmation': 'Live Confirmation',
  '/host/live-confirm-history': 'Live Confirm History',
  '/host/register-live-calendar': 'Register Live Calendar',
  '/host/overview-report': 'Host Overview Report',
  '/host/script-library': 'Script Library',
};

export const getHostFeatureNameByRoute = (route: string): string => {
  const cleanRoute = route.split('?')[0];

  if (HOST_ROUTE_FEATURE_NAME_MAP[cleanRoute]) {
    return HOST_ROUTE_FEATURE_NAME_MAP[cleanRoute];
  }

  // Match detail routes like /host/livestream-calendar/123
  if (cleanRoute.startsWith('/host/livestream-calendar/')) {
    return 'Livestream Detail';
  }

  const matchedParent = Object.keys(HOST_ROUTE_FEATURE_NAME_MAP).find((key) =>
    cleanRoute.startsWith(`${key}/`),
  );
  if (matchedParent) {
    return HOST_ROUTE_FEATURE_NAME_MAP[matchedParent];
  }

  return cleanRoute.replace(/^\/host\/?/, '').replace(/-/g, ' ') || 'Host Portal';
};

export const isTrackableHostRoute = (route: string): boolean => {
  const cleanRoute = route.split('?')[0];
  return cleanRoute.startsWith('/host');
};
